<!--
	Copyright 2023 HALBY
	See LICENSE file for details.
 -->

<script>
	import Header from '$lib/components/Header.svelte';
	import Footer from '$lib/components/Footer.svelte';
	import '$lib/assets/css/global.scss';
	import '$lib/assets/css/app.css'
	import { onMount } from 'svelte';
	import { page } from '$app/stores';
	import { goto } from '$app/navigation';
	import { PUBLIC_BASE_PATH } from '$env/static/public';

	onMount(() => {
		let { pathname, searchParams } = $page.url;

		// 画像ファイルかどうかを判定
		const isImage = pathname.match(/\.(png|jpg|jpeg|gif|svg|webp|avif)$/i);

		// 他言語のプレフィックス（/cn, /en など）がついているか判定
		const isOtherLanguage = pathname.match(/zh-(cn|tw)/);

		pathname = pathname.replace(PUBLIC_BASE_PATH, '');
		console.log(pathname);
		// すでに /ja で始まらない & 他言語プレフィックスがない & 画像ファイルでない場合のみリダイレクト
		if (!pathname.startsWith(`/ja`) && !isOtherLanguage && !isImage) {
			goto(`${PUBLIC_BASE_PATH}/ja${pathname}`);
		}
	});
</script>

<Header />
<slot />
<Footer />
